import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68d18340"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-0" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "p-3 date-explanation" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "p-3" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_StudentsColumn = _resolveComponent("StudentsColumn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Modal, {
      ref: "export-modal",
      allowCloseOutside: true
    }, {
      header: _withCtx(() => [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t("note-taker-list.choose-date")), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_DatePicker, {
            "aria-label": "Date Picker",
            value: _ctx.feeExportFromDate,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.feeExportFromDate) = $event)),
            required: true,
            clearable: false,
            enableTimePicker: false
          }, null, 8, ["value"]),
          _createElementVNode("button", {
            id: "exportBtn",
            type: "button",
            class: "btn btn-sm btn-primary",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.exportFeeBasisData()), ["prevent"]))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "file-excel" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("note-taker-list.export")), 1)
          ]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("note-taker-list.choose-date-explanation")), 1)
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Modal, { ref: "error-modal" }, _createSlots({
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("shared.popup-error.message")), 1)
      ]),
      _: 2
    }, [
      (_ctx.noteTaker !== null)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("shared.popup-error.title")), 1)
            ])
          }
        : undefined
    ]), 1536),
    _createVNode(_component_Accordion, null, {
      button: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("shared.search-and-filter")), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Search, {
            value: _ctx.search,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
            onSearchChanged: _ctx.onSearchChange
          }, null, 8, ["value", "onSearchChanged"])
        ])
      ]),
      _: 1
    }),
    _hoisted_7,
    _createVNode(_component_Table, {
      rows: _ctx.rows,
      hiddenColumns: _ctx.hiddenColumns,
      sortColumn: _ctx.sortColumn,
      "onUpdate:sortColumn": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sortColumn) = $event)),
      ascending: _ctx.ascending,
      "onUpdate:ascending": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ascending) = $event)),
      stickyFirstColumn: "",
      showPagination: "",
      allowChangeRowPerPage: "",
      showNumRows: "",
      unsortableColumns: _ctx.unsortableColumns,
      pagingData: _ctx.pagingData,
      pageHeading: _ctx.pageHeading,
      useSpinner: true,
      isLoading: _ctx.isLoading,
      onPageNumberChanged: _ctx.onPageNumberChange,
      onSortChanged: _ctx.onSortChange,
      onPageSizeChanged: _ctx.onPageSizeChange
    }, {
      actions: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary exportBtn",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openExportDateModal(_ctx.exportTypeAccounting)), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "file-excel" }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("note-taker-list.export-fee-accounting")), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary exportBtn",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.openExportDateModal(_ctx.exportTypeBasis)), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "file-excel" }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("note-taker-list.export-fee-basis")), 1)
        ])
      ]),
      td: _withCtx((data) => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`person.${data.col}`)), 1)
      ]),
      default: _withCtx((data) => [
        (data.col === 'status')
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t(`note-taker-status.${data.val}`)), 1))
          : _createCommentVNode("", true),
        (data.col === 'students')
          ? (_openBlock(), _createBlock(_component_StudentsColumn, {
              key: 1,
              students: data.val
            }, null, 8, ["students"]))
          : _createCommentVNode("", true),
        (data.col === 'personalId')
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: { name: 'NoteTakerDetails', params: { id: data.row.id } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.val), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          : _createCommentVNode("", true),
        (
          data.col !== 'status' &&
          data.col !== 'students' &&
          data.col !== 'personalId'
        )
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(data.val), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["rows", "hiddenColumns", "sortColumn", "ascending", "unsortableColumns", "pagingData", "pageHeading", "isLoading", "onPageNumberChanged", "onSortChanged", "onPageSizeChanged"])
  ], 64))
}